
import React from "react";
import { useTheme } from "@material-ui/core";
import HvIconBase from "./IconBase";

const sizeSelector = (iconSize, height, width) => {
  if (height && width) {
    return { width, height };
  }

  switch (iconSize) {
    case "XS":
      return { width: 12, height: 12 };
    default:
    case "S":
      return { width: 16, height: 16 };
    case "M":
      return { width: 32, height: 32 };
    case "L":
      return { width: 96, height: 96 };
  }
};

const Online = ({
  color,
  iconSize = "S",
  viewbox = "0 0 16 16",
  height,
  width,
  semantic,
  inverted = false,
  svgProps,
  ...others
}) => {
  const theme = useTheme();
  const getColor = c => theme.palette?.[c] || c;
  const colorArray = 
    (typeof color === "string" && [getColor(color)]) ||
    (Array.isArray(color) && color.map?.(getColor)) ||
    [theme.palette.acce1];

  if (semantic) {
    colorArray[0] = theme.palette?.[semantic] || colorArray[0];
  }

  if (inverted && colorArray[1]) {
    colorArray[1] = colorArray[0];
    colorArray[0] = "none";
  }

  const size = sizeSelector(iconSize, height, width);

  return (
    <HvIconBase name="Online" iconSize={iconSize ?? "S"} {...others}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewbox} height={size.height} width={size.width}   focusable={false} {...svgProps}>
  <path fill={colorArray[0]} className="color0"  d="M3.00051 15.99949a2.946 2.946 0 01-3-2.891q-.001-.05449 0-.109a2.946 2.946 0 012.891-3q.0545-.001.109 0a2.946 2.946 0 013 2.891q.001.05449 0 .109a2.946 2.946 0 01-2.891 3q-.05451.00101-.109 0zm0-5a2 2 0 102 2 2 2 0 00-2-2zM2 5v1a8 8 0 018 8h1a9 9 0 00-9-9zm0-4v1a12 12 0 0112 12h1A13 13 0 002 1z" />
</svg>
    </HvIconBase>
)};

Online.propTypes = HvIconBase.propTypes;

export default Online;